import { TokuInformationT } from 'types/tokuInformation';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import storage from './encryptedStorage';

const baseInformation: TokuInformationT = {
  customerId: '',
  subscriptionId: '',
};

interface TokuInformationStateI {
  tokuInformation: TokuInformationT;
  setDefaultTokuInformation: () => void;
  setTokuInformation: (information: TokuInformationT) => void;
}

const useTokuInformationStore = create<TokuInformationStateI>()(
  persist(
    (set, get) => ({
      tokuInformation: baseInformation,
      setDefaultTokuInformation: () => set({ tokuInformation: baseInformation }),
      setTokuInformation: (tokuInformation) => set({ tokuInformation }),
    }),
    {
      name: 'deceso-toku-storage',
      storage,
    }
  )
);

export default useTokuInformationStore;
